import mapValues from 'lodash-es/mapValues'

import { BirdviewSection } from '../DashboardBirdview.constants'
import {
  checkIsBirdviewDocFlowsViewable,
  getBirdviewSection,
  getBirdviewTiles,
} from '../DashboardBirdview.utils'

import {
  BIRDVIEW_OVERSIGHT_LAYOUT,
  BIRDVIEW_OVERSIGHT_TILES,
  BirdviewOversightWidget,
} from './BirdviewOversight.constants'

export function getBirdviewOversightLayout(sectionsPermissions) {
  return checkIsBirdviewDocFlowsViewable(sectionsPermissions)
    ? BIRDVIEW_OVERSIGHT_LAYOUT
    : mapValues(BIRDVIEW_OVERSIGHT_LAYOUT, column =>
        column.filter(widget => widget !== BirdviewOversightWidget.DocFlows)
      )
}

export function getBirdviewOversightSections(sections) {
  return {
    activities: getBirdviewSection(sections[BirdviewSection.Activities]),
    attention: getBirdviewSection(sections[BirdviewSection.Attention]),
    communication: getBirdviewSection(sections[BirdviewSection.Communication]),
    criticalRequests: getBirdviewSection(
      sections[BirdviewSection.CriticalRequests]
    ),
    docFlows: getBirdviewSection(sections[BirdviewSection.DocFlows]),
    greta: getBirdviewSection(sections[BirdviewSection.Greta]),
    portfolio: getBirdviewSection(sections[BirdviewSection.Properties]),
    teamLoad: getBirdviewSection(sections[BirdviewSection.TeamLoad]),
    tiles: getBirdviewTiles({
      definitions: BIRDVIEW_OVERSIGHT_TILES,
      sections,
    }),
  }
}

export function getBirdviewOversightWidgetTitleKeys(isTeamScope) {
  return {
    [BirdviewOversightWidget.Activities]: isTeamScope
      ? 'DashboardBirdview.TeamActivitiesTitleKey'
      : 'DashboardBirdview.MyActivitiesTitleKey',
    [BirdviewOversightWidget.Attention]: 'DashboardBirdview.AttentionTitleKey',
    [BirdviewOversightWidget.Communication]: isTeamScope
      ? 'DashboardBirdview.TeamCommunicationsTitleKey'
      : 'DashboardBirdview.MyCommunicationsTitleKey',
    [BirdviewOversightWidget.CriticalRequests]: isTeamScope
      ? 'DashboardBirdview.TeamCriticalRequestsTitleKey'
      : 'DashboardBirdview.MyCriticalRequestsTitleKey',
    [BirdviewOversightWidget.DocFlows]: 'DashboardBirdview.DocFlowsTitleKey',
    [BirdviewOversightWidget.Greta]: 'DashboardBirdview.GretaTitleKey',
    [BirdviewOversightWidget.Portfolio]: 'DashboardBirdview.PortfolioTitleKey',
    [BirdviewOversightWidget.TeamLoad]: 'DashboardBirdview.TeamLoadTitleKey',
  }
}
